import { Divider, Stack } from "@mui/material";
import SelectControl from "components/form/SelectControl";
import SwitchControl from "components/form/SwitchControl";
import TextFieldControl from "components/form/TextFieldControl";
import useIsCreate from "hooks/useIsCreate";
import { useFormContext } from "react-hook-form";
import { InterviewInputs } from "../types";

const MAX_FOLLOWUPS_OPTIONS = [
  {
    label: "0",
    value: "0",
  },
  {
    label: "1",
    value: "1",
  },
  {
    label: "2",
    value: "2",
  },
  {
    label: "3",
    value: "3",
  },
  {
    label: "4",
    value: "4",
  },
  {
    label: "5",
    value: "5",
  },
];

const InterviewSwitch = () => {
  const isCreate = useIsCreate();
  const form = useFormContext<InterviewInputs>();
  const isInterview = form.watch("isInterview");
  const maxFollowups = form.watch("maxFollowups");

  return (
    <Stack
      spacing={1}
      useFlexGap>
      <SwitchControl
        name='isInterview'
        label='Диалоговое интервью'
        tooltipTitle='Оценка проходит в диалоговом формате. Возможны уточняющие вопросы по ответам кандидата.'
        disabled={!isCreate}
      />
      {isInterview && (
        <>
          <SelectControl
            items={MAX_FOLLOWUPS_OPTIONS}
            name='maxFollowups'
            label='Максимум уточнений на вопрос'
            disabled={!isCreate}
            rules={{ required: isInterview }}
            sx={{
              backgroundColor: "bgSwitch",
            }}
          />
          {maxFollowups !== "0" && (
            <TextFieldControl
              name='threshold'
              type='number'
              label='Порог для уточняющего вопроса'
              disabled={!isCreate}
              placeholder='От 0 до 100'
              rules={{
                required: true,
                min: {
                  value: 0,
                  message: "Минимальное значение - 0",
                },
                max: {
                  value: 100,
                  message: "Максимальное значение - 100",
                },
              }}
            />
          )}
        </>
      )}
      <Divider />
    </Stack>
  );
};

export default InterviewSwitch;
